
if (typeof ProductBundle !== 'function') {

  class ProductBundle extends HTMLElement {
    constructor() {

      super()
      this.storeSelector = document.querySelector('store-selector[data-main-selector]')
      this.defaultAddToCartText = this.getAttribute('data-add-to-cart-text')
      this.defaultOutOfStockText = this.getAttribute('data-out-of-stock-text')

      if (this.storeSelector) {
        this.storeSelector.addEventListener('storechanged', this.updateForm.bind(this))
      }

      const event = new Event('product-bundle-recommendations-loaded')

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('product-bundle')

          if (innerHTML) {
            const productCount = Number(innerHTML.dataset.productCount)
            if (productCount === 0) return
            this.innerHTML = innerHTML.innerHTML
            this.dispatchEvent(event)
          }
        })
        .catch(e => {
          console.error(e)
        })
        .finally(() => {
          this.init()
        })

    }

    init() {
      this.form = this.querySelector('[data-add-to-cart-form]')
      this.productForm = this.form.querySelector('product-form')
      this.addToCart = this.productForm.querySelector('[type="submit"]')
      this.addToCartText = this.addToCart.querySelector('.button__text')
      this.productForm.addEventListener('add-to-cart', this.updateCart.bind(this))
      this.addEventListener('variant-selector:changed', this.updateForm.bind(this))
      this.updateForm()
    }

    updateCart() {
      if (!document.body.classList.contains('template-cart')) {
        document.getElementById('site-cart-sidebar').show()
      }
      if (document.getElementById('cart-recommendations')) {
        document.getElementById('cart-recommendations').generateRecommendations()
      }
      document.querySelectorAll('[data-header-cart-total').forEach(elm => {
        elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent
      })
      document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
        elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent
      })
    }

    async updateForm() {
      const inputIds = this.form.querySelectorAll('[name^="id"]')
      const products = Array.from(this.querySelectorAll('product-item quick-add-to-cart'))
      if (products.length > 0) {
        for (const [idx, product] of products.entries()) {
          await product.locationPromise
          inputIds[idx].value = product.currentVariant.id
        }
        const hasUnavailableVariant = products.some(
          product => !product.currentVariant.available
        )
        this.updateAddToCart(hasUnavailableVariant)
      }
    }

    updateAddToCart(disabled) {
      if (disabled) {
        this.addToCart.disabled = true
        if (this.addToCartText) {
          this.addToCartText.textContent = this.defaultOutOfStockText
            || window.KROWN.settings.locales.products_sold_out_variant
        }
      } else {
        this.addToCart.disabled = false
        if (this.addToCartText) {
          this.addToCartText.textContent = this.defaultAddToCartText
            || window.KROWN.settings.locales.products_add_to_cart_button
        }
      }
    }

  }

  if (typeof customElements.get('product-bundle') == 'undefined') {
    customElements.define('product-bundle', ProductBundle)
  }

}
